<template>
    <div v-if="canShow('体质特征') && info && module && module.data">
        <div v-for="(items, index) in module.data" :key="index">
            <div v-if="items.module_name == '体质特征'">
                <div class="tips"></div>
                <div class="sick-box">
                    <div class="risk">{{ items.module_name }}</div>
                </div>
                <div class="assessment">
                    <div class="sick-list flex flex-w">
                        <div class="new-sick green-sick" v-if="info.sick_text_array && info.sick_text_array.length == 1 && info.sick_text_array[0] == '平衡'">平衡</div>
                        <div v-else :class="{ active: item1.active }" v-for="(item1, index1) in items.description_list" :key="index1" class="new-sick new-easy" @click="() => change({ index: index, index1: index1 })">
                            {{ formatSyndrome(item1.syndrome_name) }}<span v-if="info.report_type == 1 && isStep20">({{ item1.index == 0 ? '主' : '兼' }})</span>
                        </div>
                    </div>
                    <div class="sick-list flex flex-w">
                        <div v-for="(item2, index2) in items.description_list" :key="index2">
                            <div v-if="item2.list && item2.active && item2.list.length > 1" class="flex flex-v">
                                <div v-for="(item3, index3) in item2.list" :key="index3">
                                    <div class="new-sick new-green" :class="{ active: item3.active }" v-if="item3.module_value[0].value" @click="() => changeTwo({ index: index, index1: index2, index2: index3 })">{{ item3.module_value[0].value }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(item2, index3) in items.description_list" :key="'desc-' + index3">
                        <div v-if="item2.list && item2.active">
                            <div v-for="(item3, index3b) in item2.list" :key="index3b">
                                <div v-if="item3.active" class="sick-dosc">
                                    <div v-for="(item4, index4) in item3.module_value" :key="index4">
                                        <div v-if="index4 > 0">
                                            <div class="sick-title">{{ item4.title }}</div>
                                            <div class="sick-text" v-html="zhFilter(item2.syndrome_name, item4.value, info.sex, '体质特征')"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { moduleMixin, isFlowStep20, formatModuleSyndromeName, zhFilter } from '../helpers';

export default {
    name: 'ReportFeature',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info', 'module']),
        isStep20() { return isFlowStep20(this.info); }
    },
    methods: {
        zhFilter,
        formatSyndrome(name) { return formatModuleSyndromeName(name, this.info); },
        ...mapMutations('report', ['change', 'changeTwo'])
    }
};
</script>
<style lang="scss" scoped>
@import './Feature.scss';
</style>
